import { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

export const INTENTS = {
  ADD_INBOX: 'addinbox',
};

// Automatic handling of the `intent` url parameter, which can be used to signify some additional action
// that needs to be taken when a route is visited.
export const useIntent = (
  intent: string,
  callback?: () => void,
  clearOnMatch = true
) => {
  const location = useLocation();
  const history = useHistory();

  const params = new URLSearchParams(location.search);
  const parsedIntent = params.get('intent');

  useEffect(() => {
    if (intent === parsedIntent) {
      callback?.();
      if (clearOnMatch) {
        history.replace(location.pathname);
      }
    }
  }, [callback, clearOnMatch, history, intent, location, parsedIntent]);
};
